module.exports = __webpack_public_path__ + "static/media/mcr.2c9deea2.jpg";